import React, { useMemo, useState } from 'react';

const TabbedSection = ({
  tabs = [],
  activeKey,
  onChange,
  headerRight = null,
  variant = 'pills',
}) => {
  const safeTabs = Array.isArray(tabs) ? tabs.filter(Boolean) : [];
  const firstKey = safeTabs[0]?.key ?? 'tab-0';

  const isControlled = activeKey !== undefined && activeKey !== null;
  const [internalKey, setInternalKey] = useState(firstKey);
  const currentKey = isControlled ? activeKey : internalKey;

  const currentTab = useMemo(() => (
    safeTabs.find((t) => t.key === currentKey) || safeTabs[0] || null
  ), [safeTabs, currentKey]);

  const setKey = (key) => {
    if (!key) return;
    if (!isControlled) setInternalKey(key);
    if (typeof onChange === 'function') onChange(key);
  };

  if (safeTabs.length === 0) return null;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {safeTabs.map((t) => {
            const isActive = t.key === currentKey;
            if (variant === 'buttons') {
              return (
                <button
                  key={t.key}
                  type="button"
                  className={isActive ? 'btn-primary btn-sm' : 'btn-secondary btn-sm'}
                  onClick={() => setKey(t.key)}
                >
                  {t.label}
                </button>
              );
            }
            return (
              <button
                key={t.key}
                type="button"
                className={`filter-pill ${isActive ? 'active' : ''}`}
                onClick={() => setKey(t.key)}
              >
                {t.label}
              </button>
            );
          })}
        </div>
        {headerRight && (
          <div style={{ marginLeft: 'auto' }}>
            {headerRight}
          </div>
        )}
      </div>

      <div>
        {currentTab?.content}
      </div>
    </div>
  );
};

export default TabbedSection;

